function update_bookmarks() {
  
  var $bookmarkBtns = $('.js-bookmark');
  var $modal = $("#addBookmarkFolder");
  var $modalConnect = $("#notConnectedModal");
  var $span = $(".close");

  // verify bookmarks status
  var $bookmarkIds = $bookmarkBtns.map(function() {
    return $(this).data("id");
  }).get();

  $.ajax({
    type: 'GET',
    url: ajaxurl,
    data: {
      action: 'verify_bookmark_status',
     // bookmarks: $bookmarkIds
    },
    success: function(data){
      if(data) {
        if (data.isConnected) { // user connected
          data = Object.values(data.bookmarks);
          var dataInt = data.map(str => {
            return Number(str);
          });

          if(dataInt) {
            $bookmarkBtns.each(function() {
              if (dataInt.includes($(this).data("id"))) {
                $(this).addClass("is-active");
              }
            });
          }

          // change bookmark status
          $bookmarkBtns.on('click', function() {

            var $submitForm = $('#submit_save_folder_bookmark');
            var $btn = $(this);
            var $bookmarkId = $btn.data('id');
            var $laboTeaser = $(this).parents()[3];
            var $folderName = $(this).parents()[4];
            $bookmarkClass = false;

            if ($(this).hasClass('is-active')) { 
              $bookmarkClass = true;

              $.ajax({
                type: 'POST',
                url: ajaxurl,
                data: {
                  action: 'change_bookmark_status',
                  bookmark: $bookmarkId,
                  bookmarkClass : $bookmarkClass
                },
                success: function(data){
                  if(!data.response) {
                    $btn.removeClass('is-active');
                    if($btn.hasClass('js-del-bookmark')) {
                      $laboTeaser.remove();
                      if(data.nomore_bookmark) {
                        $folderName.remove();
                      }
                      $(check_folders_bookmarks);
                    }
                  }                  
                },
              });

            } else {
              var $modal = $("#addBookmarkFolder");
              $modal.show();
              $submitForm.on('click', function(e) {

                var folderName = null;

                if($('#folder_bookmark_select').val() != '') {
                  folderName = $('#folder_bookmark_select').val();
                } 
                if($('#folder_bookmark_name').val() != '') {
                  folderName = $('#folder_bookmark_name').val();
                }

                if (folderName != null) {
                  $.ajax({
                    type: 'POST',
                    url: ajaxurl,
                    data: {
                      action: 'change_bookmark_status',
                      folderName: folderName,
                      bookmark: $bookmarkId,
                      bookmarkClass : $bookmarkClass
                    },
                    success: function(data){
                      if(data) {
                        $btn.addClass('is-active');
                        folderName = '';
                        $('#folder_bookmark_select').val('');
                        $('#folder_bookmark_name').val('');
                        $modal.hide();
                        $(check_folders_bookmarks);
                      }
                    },
                  });
                } else {
                  $('#error_message').html('Un nom de dossier doit être choisi');
                }
              });
            }

          });
        } else { // user not connected
          $bookmarkBtns.on('click', function() {
            $modalConnect.show();
          });
        }
      }
    }
  });

  $span.on('click', function() {
    $modal.hide();
  });
  
  $span.on('click', function() {
    $modalConnect.hide();
  });
  
}

$(window).on('click', function(event) {
  var notConnectedModal = $("#notConnectedModal");
  var modal = $("#addBookmarkFolder");
  var modalEdit = $("#editBookmarkFolderName");
  var target = $(event.target);
  if (target.is(modal)) {
    modal.hide();
  }
  if (target.is(notConnectedModal)) {
    notConnectedModal.hide();
  }
  if (target.is(modalEdit)) {
    modalEdit.hide();
  }
});

function check_folders_bookmarks() {
  $.ajax({
    type: "GET",
    url: ajaxurl,
    data: {
        action: 'pil_check_folders_bookmarks',
    },
    success: function(data){
      $('.js-bookmarks-modal-content').html(data.content_select_bookmark);
      $('.js-profile-bookmarks').html(data.content_profile_bookmarks);
      $(update_bookmarks);
      $(edit_folder_name);
    },
  });
}

function edit_folder_name() {
  var $modalEdit = $("#editBookmarkFolderName");
  var folderNameOld;
  var folderNameNew;
  var $close = $(".close");

  
  $('.js-edit-name-bookmark-folder').on('click', function() {
    folderNameOld = $(this).data("folder"); 
    $modalEdit.show();
    $('#edit_folder_bookmark_name').val(folderNameOld);

    $('#edit_folder_bookmark_name').on('change', function() {
      folderNameNew = $(this).val(); 
    });

    var $submitForm = $('#submit_edit_folder_bookmark');

    $submitForm.on('click', function(e) {
      $.ajax({
        type: "POST",
        url: ajaxurl,
        data: {
            action: 'pil_edit_bookmark_folder',
            folderNameNew: folderNameNew,
            folderNameOld: folderNameOld
        },
        success: function(data){
          $modalEdit.hide();
          check_folders_bookmarks();
        },
      });
    });
  });  
  
  $close.on('click', function() {
    $modalEdit.hide();
  });
    
}

//$(update_bookmarks);
$(check_folders_bookmarks);
